var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOver),expression:"isOver"}],ref:"overlay",attrs:{"id":"drag-and-drop-overlay"},on:{"click":function($event){return _vm.hideOverlay()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }